<div class="tr-summary">
  <!-- Sticky Column -->
  <div class="td col-id sticky-col">
    <div class="layout-row layout-align-start-center gap-5">
       <bringoz-button type="tertiary" size="fit" (onClick)="onClose.emit()">
         <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
       </bringoz-button>

      <!--Toggle Tasks Expanded-->
      <bringoz-button type="tertiary"
                      size="fit"
                      bringoz-id-generator="group-routes-panel"
                      aria-label="bundle toggle"
                      [ngbTooltip]="(!!isGroupedRoutes ? 'Ungroup' : 'Group' | translate) + ' ' + ('Tasks' | translate)"
                      (onClick)="onToggleGroupedRoutes.emit()">
        <bringoz-icon iconName="{{!!isGroupedRoutes ? 'ungroup' : 'group'}}"
                      class="bringoz-icon-small"></bringoz-icon>
      </bringoz-button>

       <app-planning-route-action-menu *ngIf="isShowActionMenu"
                                       [route]="route"
                                       (onDispatch)="onDispatch.emit($event)"
                                       (onReoptimize)="onReoptimize.emit($event)"
                                       (onPreAssignAgent)="onPreAssignAgent.emit($event)"
                                       (onPrint)="onPrint.emit($event)"
                                       (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                       (onDelete)="onDelete.emit($event)"
                                       (onFeedback)="onFeedback.emit($event)">
       </app-planning-route-action-menu>

      <bringoz-button type="tertiary"
                      size="fit"
                      (onClick)="onEditResourceAllocation.emit({route: route, event: $event}); $event.stopPropagation()">
        <bringoz-icon iconName="edit-outline"></bringoz-icon>
      </bringoz-button>

       <bringoz-button type="tertiary" size="fit" (onClick)="onLockRouteChange.emit({id: route.id, locked: !route.locked})">
         <bringoz-icon [iconName]="route.locked ? 'lock' : 'lock-open-outline'" classSize="lg" fill="#484848"></bringoz-icon>
       </bringoz-button>

       <bringoz-button type="tertiary" size="fit" (onClick)="onToggleVisible.emit(!isVisible)">
         <bringoz-icon [iconName]="isVisible ? 'eye-on' : 'eye-off'" classSize="lg" fill="#484848"></bringoz-icon>
       </bringoz-button>

       <div class="index-border" [style.background-color]="getRouteColor()"></div>
        <div class="flex layout-row clickable gap-5 text-ellipsis align-items-center" (click)="onChangeRouteResourceClick($event); $event.stopPropagation()">
          <span class="text-ellipsis font-weight-600">
            {{ route.name ? route.name : 'Route' | translate }} {{ route.resource?.allocationName || route.resource?.vehicleName }}
          </span>
          <span id="route-resource-arrow">▾</span>
        </div>
    </div>
  </div>

  <div *ngIf="settings?.columns?.id" class="td col-route-id">
    <div class="flex layout-row"
         (mouseenter)="isShowCopyBtn=true"
         (mouseleave)="isShowCopyBtn=false">
      <span class="br-body-1 text-ellipsis">{{ route.id }}</span>
      <app-text-copy-button [isShowCopyBtn]="isShowCopyBtn"
                            [text]="route.id">
      </app-text-copy-button>
    </div>
  </div>

  <div *ngIf="settings?.columns?.status" class="td col-status">
    <app-bringoz-status-tag [status]="getRouteIsRunning() ? (route.actionProcess.isDispatching ? 'DISPATCHING' : 'OPTIMIZING') : route.status"></app-bringoz-status-tag>
  </div>

  <div *ngIf="settings?.columns?.agent" class="td col-agent">
    <span class="text-ellipsis">{{ route.resource?.agentName || '---' }}</span>
  </div>

  <div *ngIf="settings?.columns?.vehicle" class="td col-vehicle">
    <span class="text-ellipsis">{{ logisticsVehicleName || route.resource?.vehicleName || '---' }}</span>
  </div>

  <div *ngIf="settings?.columns?.timeWindow" class="td col-time-window">
    <span class="text-ellipsis">{{ dateRange | timeWindow }}</span>
  </div>

  <div *ngIf="settings?.columns?.duration" class="td col-duration">
    {{ route.totals?.totalTimeSec | bringozTimeConvert }}
  </div>

  <div *ngIf="settings?.columns?.distance" class="td col-distance">
    {{ route.totals?.totalDistanceMeter | bringozDistance:'---':true }}
  </div>

  <div *ngIf="settings?.columns?.jobsCount" class="td col-jobs-count gap-5">
    {{ route.jobIds?.length }}
  </div>

  <div *ngIf="settings?.columns?.activitiesCount" class="td col-activities-count">
    {{ route.totals?.totalStopsCount }}
  </div>

  <div *ngIf="settings?.load?.weight" class="td col-load col-load-weight">{{ route.totals?.totalLoad | bringozWeight:true:'---':true }}</div>

</div>
